// Records whether a dialog is open, so a toast knows to leave the keyboard focus alone.

type Dialog = object;

const openDialogs = new Set<Dialog>();
const listeners = new Set<() => void>();

const notify = () => listeners.forEach(listener => listener());

const addDialog = (dialog: Dialog) => {
  openDialogs.add(dialog);
  notify();
};

const removeDialog = (dialog: Dialog) => {
  if (openDialogs.delete(dialog)) {
    notify();
  }
};

const hasOpenDialog = () => openDialogs.size > 0;

const subscribeToDialogs = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export { addDialog, hasOpenDialog, removeDialog, subscribeToDialogs };
